import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import WebService from "../Services/WebService";
import { useDispatch, useSelector } from "react-redux";
import { setAppVersion } from "../config/action";

const Main = () => {
  const version = useSelector(
    (state: any) => state?.items?.app_version
  );

  const dispatch = useDispatch()
  useEffect(() => {
    const versionInterval = setInterval(() => {
      getLatestVersion();
    }, 60000);

    const reloadInterval = setInterval(() => {
      window.location.reload();
    }, 30 * 60 * 1000);

    return () => {
      clearInterval(versionInterval);
      clearInterval(reloadInterval);
    };
  }, []);

  const getLatestVersion = () => {
    return WebService.getAPI({
      action: `dashboard-version`,
      body: null,
    })
      .then((res: any) => {
        if (res?.result?.version !== version) {
          dispatch(setAppVersion(res?.result?.version))
          window.location.reload();
        }
      })
      .catch((error: any) => {
        console.log("error", error);
        return null;
      });
  };


  return (

    <div id="main-app">
      <div className="app-body kpi-dahboard-page">
        <Outlet />
      </div>
    </div>
  );
};

export default Main;
